import { render, staticRenderFns } from "./networkclassroomIndex.vue?vue&type=template&id=b90a29a4&scoped=true&"
import script from "./networkclassroomIndex.vue?vue&type=script&lang=js&"
export * from "./networkclassroomIndex.vue?vue&type=script&lang=js&"
import style0 from "./networkclassroomIndex.vue?vue&type=style&index=0&id=b90a29a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90a29a4",
  null
  
)

export default component.exports